let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fgtjT")).then(() => parcelRequire('d7RpF'));